import { Controller } from "@hotwired/stimulus"

// Kontroler formularza zadań cyklicznych
// Pokazuje/ukrywa sekcje zależnie od wybranego źródła zadania (template_source) i przestawia
// picker między szablonami zadań a istniejącymi zadaniami - każde źródło szuka w innym zasobie.
export default class extends Controller {
  static targets = ["templateSection", "inlineSection", "fromTaskInfo"]
  static values = { templateUrl: String, taskUrl: String }

  connect() {
    this.updateVisibility()
  }

  sourceSelect() {
    return this.element.querySelector("select[name='recurring[template_source]']")
  }

  // Aktualnie wybrane źródło - czytamy je z selecta, żeby nie trzymać drugiej kopii stanu.
  get source() {
    return this.sourceSelect()?.value ?? null
  }

  // Zmiana źródła przestawia sekcje i picker. Wcześniejszy wybór wskazuje na inny model,
  // więc go czyścimy - inaczej zostałby zapisany id z niewłaściwej tabeli.
  sourceChanged() {
    this.updateVisibility()
    this.resetPicker()
  }

  updateVisibility() {
    const isInline = this.source === "task_inline"

    // sekcje wyboru szablonu - ukryj dla inline
    this.templateSectionTargets.forEach(el => {
      el.classList.toggle("hidden", isInline)
    })

    // sekcja danych inline - pokaż dla inline
    this.inlineSectionTargets.forEach(el => {
      el.classList.toggle("hidden", !isInline)
    })

    // podpowiedź o dodatkowych polach kopiowanych z zadania
    this.fromTaskInfoTargets.forEach(el => {
      el.classList.toggle("hidden", this.source !== "task_from_task")
    })
  }

  resetPicker() {
    if (this.source === "task_inline") { return }

    const controller = this.pickerController()
    if (!controller) { return }

    controller.clearValue()
    controller.setSearchUrl(this.source === "task_from_task" ? this.taskUrlValue : this.templateUrlValue)
  }

  // Picker szablonu siedzi w sekcji szablonu (sekcja inline ma własne pickery, których nie ruszamy).
  pickerController() {
    const wrapper = this.templateSectionTargets
      .map(el => el.querySelector(".intum-select-wrapper"))
      .find(el => el)
    if (!wrapper) { return null }

    return this.application.getControllerForElementAndIdentifier(wrapper, "intum-select")
  }
}
